import css from './organizations.module.css'
import NavigationBreadcrumbs from 'src/navigation/components/NavigationBreadcrumbs'
import MainLayout from '@/shared/Layouts/MainLayout'
import { useState } from 'react'
import SearchInput from '@/shared/Inputs/SearchInput'
import CreateEntityButton from '@/shared/Buttons/CreateEntityButton'
import CreateOrganizationSidePage from '@/pages/Organizations/components/CreateOrganizationSidePage'
import OrganizationsTable from '@/pages/Organizations/components/OrganizationsTable'
import OrganizationSidePage from '@/pages/Organizations/components/OrganizationSidePage'
import useSidePageWithTableCtrl from '@/shared/SidePage/useSidePageWithTableCtrl.ts'
import { IOrganization } from '@/pages/Organizations/organizations.types.ts'
import { useRecoilValue } from 'recoil'
import organizationsAtom from '@/pages/Organizations/organizations.atom.ts'
import { useSearchParams } from 'react-router-dom'
import useOrganization from '@/pages/Organizations/hooks/useOrganization.ts'
import ProtectedContent from '@/services/rights/ProtectedContent'
import useTitle from '@/shared/hooks/useTitle'

const OrganizationsPage = () => {
  useTitle('Организации')
  const [search, setSearch] = useState('')
  const [createSidePageOpen, setCreateSidePageOpen] = useState(false)

  const [query] = useSearchParams()
  const queryParamsOrganizationId = query.get('organizationId') || null
  const initialSelectedOrganizationId = useOrganization(+queryParamsOrganizationId)

  const items = useRecoilValue(organizationsAtom).items
  const sidePageCtrl = useSidePageWithTableCtrl<IOrganization>(items, {
    selectedItem: initialSelectedOrganizationId.organization,
    open: Boolean(initialSelectedOrganizationId),
  })

  return (
    <MainLayout>
      <div className={css.wrapper}>
        <div className="flex-lines gap16 height100">
          <NavigationBreadcrumbs />
          <div className="flex-lines gap4">
            <h2 className="text-heading-3">Организации</h2>
          </div>
          <div className={css.mainCard}>
            <div className="inline-flex-gap gap8">
              <ProtectedContent requiredRight="organizations:create">
                <CreateEntityButton onClick={() => setCreateSidePageOpen(true)} text="Добавить организацию" />
              </ProtectedContent>
              <SearchInput value={search} name="search" onChange={setSearch} placeHolder="Поиск по организациям" />
            </div>
            <OrganizationsTable onClick={sidePageCtrl.handleItemPageOpen} />
          </div>
        </div>
      </div>
      <OrganizationSidePage
        onCloseAnimationEnd={sidePageCtrl.handleCloseAnimationEnd}
        open={sidePageCtrl.sidePageOpen}
        onClose={sidePageCtrl.handleClosePage}
        organization={sidePageCtrl.selectedItem}
      />
      <CreateOrganizationSidePage open={createSidePageOpen} onClose={() => setCreateSidePageOpen(false)} />
    </MainLayout>
  )
}

export default OrganizationsPage
